<script setup lang="ts">
import vPreloadImg from '@/ts/directives/v-preload-img.ts';
import Btn from './btn.vue';
import model from '@/ts/model.ts';
import { onUnmounted, ref } from 'vue';
import { globalBlurLogic } from '@/ts/management/ui-management.ts';
import { getLangText } from '@/ts/utils/utils.ts';
import AppStoreLinks from './app-store-links.vue';

const astronautImg = import.meta.glob('@/assets/astronaut.*', { eager: true, query: '?url', import: 'default' });
const storeLink = model.isIOS ? model.clientConfig.appConfig?.appstoreLink : model.clientConfig.appConfig?.playstoreLink;

</script>

<template>
    <div class="app-advert" :class="{'on-top': model.uiData.atTop, 'blur': globalBlurLogic}">
        <div class="inner">
            <template v-if="!model.isMobile">
                <div class="col">
                    <span>{{ getLangText('DownloadOurAppLabel') }}</span>
                </div>
            </template>
            <div class="col">
                <img v-preload-img="astronautImg">
                <a :href="storeLink" target="_blank">
                    <btn skin="primary" v-mobile>{{ getLangText('DownloadNowLabel') }}</btn>
                </a>
            </div>
            <div class="col">
                <app-store-links :loc="'header'" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @use '@/scss/shared';
    @use 'sass:color';
    .app-advert{
        position: fixed;
        top:0;
        left:0;
        z-index: 201;
        display: flex;
        width: 100%;
        height: 60px;
        background-color: #000;
        transition: transform .25s, filter .25s, opacity .25s;
        @include shared.site() using($site-key){
            border-bottom: 1px solid color.adjust(shared.theme-color('comp3_3', $site-key), $alpha: -.5);
        }
        &:not(.on-top){
            transform: translateY(-100%);
        }
        &.blur{
            opacity: .15;
        }
        & > .inner{
            display: flex;
            position: relative;
            height: inherit;
            width: 100%;
            max-width: shared.$max-resolution;
            margin: 0 auto;
            justify-content: space-between;
            & > .col{
                display: flex;
                justify-content: center;
                align-items: center;
                & > span{
                    padding-left: 10px;
                    @include shared.site() using($site-key){
                        color: shared.theme-color('comp3_3', $site-key);
                    }
                    @include shared.casino-section-title();
                }
                & > img{
                    width: 55px;
                    height: 55px;
                }
                & a{
                    &:link,
                    &:hover,
                    &:active,
                    &:visited{
                        text-decoration: none !important;
                    }
                }
                & :deep(button:not([data-mobile])){
                    & .inner{
                        padding: 4px 8px;
                    }
                    & .content{
                        font-size: 15px;
                    }
                    & .upper-layer{
                        height: 20px;
                    }
                }
                & :deep(button[data-mobile]){
                    & .inner{
                        padding: 2px 4px;
                    }
                    & .content{
                        font-size: 10px;
                    }
                    & .upper-layer{
                        height: 15px;
                    }
                }
            }
        }
    }
</style>